<template>
    <div
        id="assetMessage"
        :style="{ ...messageColors, ...(extendedStyle || {}) }"
        class="sc-message--text"
        v-if="getSrc()"
    >
        <span v-if="isGroupMessage" class="whatsapp-number-first" @click.stop="showWhatsappChatStarterModal = true">
            <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
            >
        </span>
        <div
            class="asset-card-gallery-wrap"
            @mouseenter="assetGalleryHovered = true"
            @mouseleave="assetGalleryHovered = false"
        >
            <!-- Previewable dosyalar: WhatsApp tarzı thumbnail kart -->
            <div
                v-if="isPreviewable"
                class="asset-card asset-card--previewable"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('message.preview')"
                @click.prevent="handleAssetClick"
            >
                <div class="asset-card__thumb">
                    <div v-if="getExt().toLowerCase() === 'pdf'" class="asset-card__thumb-scaler">
                        <iframe
                            :src="getSrc() + '#toolbar=0&navpanes=0&scrollbar=0&page=1&view=FitH&zoom=page-width'"
                            class="asset-card__thumb-iframe"
                            scrolling="no"
                            frameborder="0"
                            tabindex="-1"
                        ></iframe>
                    </div>
                    <div v-else class="asset-card__thumb-placeholder">
                        <div v-if="getExt()" :class="`fi-${getExt()}`" class="fi fi-hero">
                            <div class="fi-content">{{ getExt() }}</div>
                        </div>
                        <a-icon type="file" v-else style="font-size:48px; opacity:0.4" />
                    </div>
                    <div class="asset-card__thumb-overlay"></div>
                </div>
                <div class="asset-card__footer">
                    <div class="asset-card__icon">
                        <div v-if="getExt()" :class="`fi-${getExt()}`" class="fi">
                            <div class="fi-content">{{ getExt() }}</div>
                        </div>
                        <a-icon type="file" v-else class="asset-card__fallback-icon" />
                    </div>
                    <div class="asset-card__info">
                        <p class="asset-card__name">{{ getAssetName() }}</p>
                        <p class="asset-card__ext">{{ getExt() ? getExt().toUpperCase() : "" }}</p>
                    </div>
                    <span class="material-icons asset-card__preview-icon">open_in_new</span>
                </div>
            </div>

            <!-- Normal dosyalar: mevcut indirme kartı -->
            <a
                v-else
                class="asset-card"
                :href="getSrc()"
                download
                target="_blank"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('message.download')"
            >
                <div class="asset-card__icon">
                    <div v-if="getExt()" :class="`fi-${getExt()}`" class="fi">
                        <div class="fi-content">{{ getExt() }}</div>
                    </div>
                    <a-icon type="file" v-else class="asset-card__fallback-icon" />
                </div>
                <div class="asset-card__info">
                    <p class="asset-card__name">{{ getAssetName() }}</p>
                    <template v-if="isFilterAsset">
                        <p class="asset-card__meta">{{ $t("message.type") }}: {{ getExt() }}</p>
                        <p class="asset-card__meta">{{ $t("message.sender") }}: {{ message.raw ? message.raw.user.name : "" }}</p>
                    </template>
                    <p class="asset-card__ext" v-else>{{ getExt() ? getExt().toUpperCase() : "" }}</p>
                </div>
                <a-icon type="cloud-download" class="asset-card__download-icon" />
            </a>
            <button
                v-if="assetGalleryHovered"
                type="button"
                class="asset-gallery-open-btn"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('chatbotv2.imageView')"
                @click.stop.prevent="$emit('open-gallery', message)"
            >
                <span class="material-icons">collections</span>
            </button>
        </div>

        <Modal2
            v-if="showPreviewModal"
            :title="getAssetName()"
            :showFooter="false"
            xlarge
            @cancel="showPreviewModal = false"
        >
            <div class="asset-preview-modal">
                <div class="asset-preview-toolbar">
                    <span class="asset-preview-filename">
                        <span v-if="getExt()" :class="`fi-${getExt()}`" class="fi fi-sm"></span>
                        {{ getAssetName() }}
                    </span>
                    <a
                        :href="getSrc()"
                        download
                        target="_blank"
                        class="asset-preview-download-btn"
                    >
                        <span class="material-icons">download</span>
                        {{ $t('message.download') }}
                    </a>
                </div>
                <div class="asset-preview-frame-wrap">
                    <iframe
                        :src="getPreviewUrl()"
                        class="asset-preview-frame"
                        frameborder="0"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
        </Modal2>

        <div
            v-if="isGroupMessage"
            style="display: flex; flex-direction: row; justify-content: end; align-items: center; padding: 0 0.3rem"
        >
            <span class="sc-message-meta-new whatsapp-number" @click.stop="showWhatsappChatStarterModal = true">
                <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                    >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
                >
            </span>
        </div>

        <span
            v-if="!message.isMail && message.data.meta"
            class="asset-message-meta"
            >{{ message.data.meta }}</span
        >

        <div class="actor-info-bar" v-if="actorInfo">
            <i class="material-icons">info_outline</i>
            <span v-if="!actorInfo.link">{{ actorInfo.text }}</span>
            <router-link v-else :to="actorInfo.link" class="actor-link">
                {{ actorInfo.text }}
                <i class="material-icons" style="font-size: 10px;">open_in_new</i>
            </router-link>
        </div>

        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="whatsappAuthorNumber"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-name="whatsappAuthorName"
            />
        </Modal2>
    </div>
</template>

<script>
import log2 from "../../../utils/log2";
import _ from "lodash";
import { mapState } from "vuex";
import Modal2 from "../../common/Modal2.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import StringUtils from "../../../utils/StringUtils";

const log = log2("AssetMessage");
export default {
    name: "AssetMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        isFilterAsset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showWhatsappChatStarterModal: false,
            assetGalleryHovered: false,
            showPreviewModal: false,
        };
    },
    computed: {
        ...mapState({
            users: function (state) { return _.get(state, "user.users.data", []); },
        }),
        isGroupMessage() {
            return !!_.get(this.message, "raw.whatsappAuthor.author");
        },
        whatsappAuthorNumber() {
            return _.get(this.message, "raw.whatsappAuthor.author", "").replace(/[^0-9]/g, "");
        },
        whatsappAuthorName() {
            return _.get(this.message, "raw.whatsappAuthor.authorName", "");
        },
        isPreviewable() {
            var ext = (this.getExt() || "").toLowerCase();
            return ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"].indexOf(ext) !== -1;
        },
        actorInfo: function () {
            const data = this.message.raw || {};
            const actorDetail = data.actorDetail || {};

            if (actorDetail.type === "automation" || data.fromAutomation) {
                const automationId = actorDetail.automation || data.automationId;
                const blockId = actorDetail.blockId;
                const automationName = actorDetail.automationName;
                const text = automationName
                    ? this.$t("message.sentByAutomation", { name: automationName })
                    : this.$t("message.sentByAutomationGeneric");
                let link = null;
                if (automationId) {
                    link = "/automations/" + automationId + "/design" + (blockId ? "/block/" + blockId : "");
                }
                return { text: text, link: link };
            }

            if (actorDetail.type === "chatbot") {
                const storyId = actorDetail.chatbotStory;
                const version = actorDetail.chatbotStoryVersion;
                const blockId = actorDetail.blockId;
                const isAIAssistant = blockId && (blockId === "ai_assistant" || blockId === "AI_ASSISTANT");
                const storyName = actorDetail.chatbotStoryName;
                const text = storyName
                    ? this.$t("message.sentByChatbot", { name: storyName })
                    : this.$t("message.sentByChatbotGeneric");
                let link = null;
                if (storyId && version) {
                    link = "/chatbot/story/" + storyId + "/" + version + (blockId && !isAIAssistant ? "/block/" + blockId : "");
                }
                return { text: text, link: link };
            }

            let text = null;
            if (data.fromBroadcast || actorDetail.type === "broadcast") text = this.$t("message.sentByBroadcast");
            else if (data.fromAPI || actorDetail.type === "api") text = this.$t("message.sentByAPI");
            else {
                let username = data.username || "";
                if (!username && data.user) {
                    const userHashMap = _.keyBy(this.users, "_id");
                    if (typeof data.user === "object") {
                        username = _.get(data.user, "name", "");
                    } else {
                        username = _.get(userHashMap, "[" + data.user + "].name", "");
                    }
                }
                if (username) text = this.$t("message.sentByUser", { name: username });
            }
            return text ? { text: text, link: null } : null;
        },
    },
    methods: {
        getAssetName() {
            const assetName = this.message?.raw?.asset?.name || "Dosyayı indir";
            return assetName;
        },
        getExt() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message.ext;
            } else {
                asset = this.message.raw.asset.ext;
            }
            return asset;
        },
        getSrc() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message;
            } else {
                asset = this.message.raw.asset;
            }
            const path = asset?.path;

            if (path) {
                const isWhatsapp = path.indexOf("whatsapp") !== -1;
                const isInstagram = path.indexOf("instagram") !== -1;
                const isMessenger = path.indexOf("messenger") !== -1;
                const isTelegram = path.indexOf("telegram") !== -1;
                const isLinkedin = path.indexOf("linkedin") !== -1;
                const isApiMessages = path.indexOf("api-messages") !== -1;

                const src =
                    isWhatsapp || isInstagram || isTelegram || isMessenger || isLinkedin || isApiMessages
                        ? `https://static.supsis.live/${path}`
                        : asset.v2Format && asset.cdnUrl
                        ? asset.cdnUrl
                        : `https://static.supsis.live/${path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
                log("src", src);
                return src;
            } else {
                log("src path not found", this.message?.raw?.asset);
                return null;
            }
        },
        getWhatsappNumberColor() {
            if (this.isGroupMessage) {
                const colors = ["#1a5fb4", "#813d9c", "#c64600", "#2ec27e", "#e01b24", "#3584e4", "#9141ac", "#f5c211"];
                const index = Math.abs(this.hashCode(this.whatsappAuthorNumber)) % colors.length;
                return colors[index];
            }
            return this.messageColors.color;
        },
        handleAssetClick() {
            if (this.isPreviewable) {
                this.showPreviewModal = true;
            } else {
                var src = this.getSrc();
                if (src) {
                    window.open(src, "_blank");
                }
            }
        },
        getPreviewUrl() {
            var src = this.getSrc();
            var ext = (this.getExt() || "").toLowerCase();
            if (ext === "pdf") {
                return src;
            }
            return "https://docs.google.com/viewer?url=" + encodeURIComponent(src) + "&embedded=true";
        },
        hashCode(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
    },
    mounted() {},
    components: {
        Modal2,
        WhatsappChatStarter,
    },
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

#assetMessage {
    .asset-card-gallery-wrap {
        position: relative;
        display: block;
    }

    .asset-gallery-open-btn {
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 2;
        background: rgba(0, 0, 0, 0.55);
        border: none;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background 0.2s;

        .material-icons {
            color: #fff;
            font-size: 18px;
        }

        &:hover {
            background: rgba(0, 0, 0, 0.8);
        }
    }

    .asset-card {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        padding: 8px 10px;
        margin: 4px 2px;
        background: transparent;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        text-decoration: none;
        transition: background 0.18s ease;

        &:hover {
            background: rgba(0, 0, 0, 0.05);
            border-color: rgba(0, 0, 0, 0.15);

            .asset-card__download-icon {
                opacity: 1;
                transform: translateY(0px);
            }
        }

        &__icon {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .fi {
                font-size: 36px;
            }
        }

        &__fallback-icon {
            font-size: 28px;
            color: inherit;
            opacity: 0.6;
        }

        &__info {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        &__name {
            margin: 0;
            font-size: 13px;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 160px;
            color: inherit;
        }

        &__ext {
            margin: 0;
            font-size: 10px;
            opacity: 0.55;
            font-weight: 600;
            letter-spacing: 0.5px;
        }

        &__meta {
            margin: 0;
            font-size: 10px;
            opacity: 0.65;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 160px;
        }

        &__download-icon {
            flex-shrink: 0;
            font-size: 16px;
            opacity: 0.45;
            transform: translateY(2px);
            transition: opacity 0.18s ease, transform 0.18s ease;
            color: inherit;
        }
    }

    .asset-card__preview-icon {
        flex-shrink: 0;
        font-size: 16px;
        opacity: 0.55;
        color: inherit;
        transition: opacity 0.18s ease;
    }

    .asset-card--previewable {
        flex-direction: column;
        padding: 0;
        gap: 0;
        overflow: hidden;
        cursor: pointer;
        min-width: 200px;

        .asset-card__thumb {
            position: relative;
            width: 100%;
            height: 150px;
            overflow: hidden;
            background: #eee;
            border-radius: 8px 8px 0 0;

            // scale(0.35) uyguluyoruz; container'ı doldurmak için:
            // genişlik = 100% / 0.35 ≈ 286%
            // yükseklik = 150px / 0.35 ≈ 430px
            .asset-card__thumb-scaler {
                position: absolute;
                top: 0;
                left: 0;
                width: 286%;
                height: 430px;
                transform: scale(0.35);
                transform-origin: top left;
                overflow: hidden;
                background: #fff;
            }

            .asset-card__thumb-iframe {
                width: 100%;
                height: 100%;
                pointer-events: none;
                border: none;
                display: block;
                background: #fff;
            }

            .asset-card__thumb-placeholder {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(145deg, #f5f7fa 0%, #e4e8ef 100%);

                .fi.fi-hero {
                    font-size: 64px;
                    opacity: 0.85;
                }
            }

            .asset-card__thumb-overlay {
                position: absolute;
                inset: 0;
                background: rgba(0, 0, 0, 0);
                transition: background 0.18s ease;
                pointer-events: none;
            }
        }

        &:hover .asset-card__thumb-overlay {
            background: rgba(0, 0, 0, 0.06);
        }

        .asset-card__footer {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px 10px;

            .asset-card__icon .fi {
                font-size: 30px;
            }
        }
    }

    .fi-content {
        width: auto;
        font-size: 11px;
    }

    .asset-message-meta {
        display: block;
        text-align: left;
        font-size: 10px;
        opacity: 0.55;
        margin-top: 4px;
        padding-right: 4px;
    }

    .actor-info-bar {
        display: flex;
        align-items: center;
        gap: 3px;
        padding: 4px 4px 0;
        color: #8696a0;
        font-size: 10px;
        line-height: 1.2;

        .material-icons {
            font-size: 12px;
        }

        .actor-link {
            color: #00a5f4;
            text-decoration: underline;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 2px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                opacity: 0.8;
            }
        }
    }

    .received {
        color: #222222;
    }

    .sent {
        color: #ffffff;
    }
}

.whatsapp-number {
    cursor: pointer;

    a {
        text-decoration: underline;
    }
}

.whatsapp-number-first {
    cursor: pointer;
    font-size: smaller;
    font-weight: 200;
    letter-spacing: 2px;

    a {
        &:hover {
            text-decoration: underline;
        }
    }

    padding: 5px;
}

.sc-message-meta-new {
    font-size: 8px;
    font-weight: 300;
    color: white;
    text-align: right;
    border-radius: 6px;
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0px !important;
    margin: 5px !important;
    margin-right: 14px !important;
    margin-bottom: 14px !important;
}
</style>

<style lang="scss">
.asset-preview-modal {
    display: flex;
    flex-direction: column;
    height: 80vh;

    .asset-preview-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        background: var(--color-bg-neutral-subtle, #f5f5f5);
        border-radius: 6px 6px 0 0;
        gap: 12px;

        .asset-preview-filename {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            font-weight: 500;
            color: var(--color-text-primary-default, #222);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: calc(100% - 140px);

            .fi.fi-sm {
                font-size: 20px;
            }
        }

        .asset-preview-download-btn {
            display: flex;
            align-items: center;
            gap: 4px;
            padding: 6px 14px;
            background: #4e8cff;
            color: #fff;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 500;
            text-decoration: none;
            white-space: nowrap;
            transition: background 0.18s ease;

            .material-icons {
                font-size: 16px;
            }

            &:hover {
                background: #3a78f2;
                color: #fff;
            }
        }
    }

    .asset-preview-frame-wrap {
        flex: 1;
        overflow: hidden;
        border-radius: 0 0 6px 6px;

        .asset-preview-frame {
            width: 100%;
            height: 100%;
            border: none;
            display: block;
        }
    }
}
</style>
